const { EMAIL_TYPES } = require('@silverfort-nodelibs/common/utils/consts');

exports.SILVERFORT_RECOMMENDED_EVENTS = [
    {
        value: 1010,
        subtitle: '#1010 • Error',
        title: 'Elasticsearch database is not connected'
    },
    {
        value: 1011,
        subtitle: '#1011 • Warning',
        title: "Elasticsearch database disk space is almost full (${usedOfUnreservedPer}%). Increase VM storage or change 'Authentication Logs Cleanup (Weeks)'"
    },
    {
        value: 1022,
        subtitle: '#1022 • Warning',
        title: 'Active directory sync never executed'
    },
    {
        value: 1038,
        subtitle: '#1038 • Error',
        title: 'License has expired!'
    },
    {
        value: 1040,
        subtitle: '#1040 • Error',
        title: 'Risk engine unavailable.'
    },
    {
        value: 1052,
        subtitle: '#1052 • Warning',
        title: '${dcName}: Disconnected from Silverfort nodes.'
    },
    {
        value: 1053,
        subtitle: '#1053 • Error',
        title: "Stunnel connectivity issue of '${node.name}'"
    },
    {
        value: 1054,
        subtitle: '#1054 • Warning',
        title: 'Unable to connect to Desktop Messaging Service: ${pushService.name}'
    },
    {
        value: 1062,
        subtitle: '#1062 • Error',
        title: 'Node was unable to connect to the Admin Console - missing connection string.'
    },
    {
        value: 1063,
        subtitle: '#1063 • Warning',
        title: 'Unable to connect to the Mobile Messaging Service.'
    },
    {
        value: 1064,
        subtitle: '#1064 • Warning',
        title: 'There is no connection to CMS.'
    },
    {
        value: 11101,
        subtitle: '#11101 • Warning',
        title: "Missing 'ADSync Nodes' in protected domain named: '${currDomain.DomainName}'."
    },
    {
        value: 1143,
        subtitle: '#1143 • Warning',
        title: 'Confirm node ${node.Name} is assigned to an availability zone through Settings > Availability Zones.'
    },
    {
        value: 1144,
        subtitle: '#1144 • Warning',
        title: 'Certificate for <crt_name> will expire on <expiration_date>'
    },
    {
        value: 1145,
        subtitle: '#1145 • Warning',
        title: "Certificate for ${subject} has expired on ${endDate.format('ll')}."
    },
    {
        value: 1150,
        subtitle: '#1150 • Warning',
        title: 'Working in Offline mode, with no configured SMTP servers.'
    },
    {
        value: 1170,
        subtitle: '#1170 • Error',
        title: 'Replication status cannot be obtained. Contact the Silverfort Support team.'
    },
    {
        value: 1171,
        subtitle: '#1171 • Warning',
        title: 'The admin console is unable to replicate data. Contact the Silverfort Support team.'
    },
    {
        value: 1174,
        subtitle: '#1174 • Error',
        title: 'Failed to update the secondary admin console.'
    },
    {
        value: 4000,
        subtitle: '#4000 • Error',
        title: 'Failed to connect to ${domainName} LDAP server from host ${hostName} (LDAP error ${ldapErrorvalue})'
    },
    {
        value: 4001,
        subtitle: '#4001 • Error',
        title: 'Silverfort service account ${userName} does not have permissions to read ${domainName} domain objects'
    },
    {
        value: 4002,
        subtitle: '#4002 • Error',
        title: 'Silverfort service account ${userName} does not have permissions to read ${domainName} domain deleted objects'
    },
    {
        value: 4003,
        subtitle: '#4003 • Error',
        title: 'Cannot save data on ${hostName}. Check the relevant permissions'
    },
    {
        value: 4022,
        subtitle: '#4022 • Warning',
        title: 'AD Connect adapter ${hostName} is disconnected.'
    },
    {
        value: 2006,
        subtitle: '#2006 • Error',
        title: 'Unstable connectivity with Admin Console (web-socket)'
    },
    {
        value: 2007,
        subtitle: '#2007 • Error',
        title: 'Unstable connectivity with Admin Console (HTTPS)'
    },
    {
        value: 2023,
        subtitle: '#2023 • Warning',
        title: 'Packet datapath (reactor) exhibiting high latency'
    },
    {
        value: 2024,
        subtitle: '#2024 • Warning',
        title: 'Notification service is down'
    },
    {
        value: 2200,
        subtitle: '#2200 • Error',
        title: 'Replication to master REDIS is down'
    },
    {
        value: 2201,
        subtitle: '#2201 • Warning',
        title: 'No mobile connectivity'
    },
    {
        value: 2205,
        subtitle: '#2201 • Warning',
        title: 'No cloud messaging service connectivity'
    },
    {
        value: 2203,
        subtitle: '#2203 • Error',
        title: 'REDIS (Risk, Primary) is unavailable. Contact the Silverfort Support team.'
    },
    {
        value: 2206,
        subtitle: '#2206 • Warning',
        title: 'Microsoft certification is about to expire.'
    },
    {
        value: 2211,
        subtitle: '#2211 • Error',
        title: 'Desktop Messaging Services server is down'
    },
    {
        value: 2216,
        subtitle: '#2216 • Error',
        title: 'Desktop Messaging Service error'
    },
    {
        value: 2217,
        subtitle: '#2217 • Error',
        title: 'Desktop Messaging Service connection error - Node is not accessible'
    },
    {
        value: 2222,
        subtitle: '#2222 • Error',
        title: 'Invalid credentials for service account: <username>'
    },
    {
        value: 2225,
        subtitle: '#2225 • Error',
        title: 'Invalid credentials for machine account: <username>'
    },
    {
        value: 2230,
        subtitle: '#2230 • Error',
        title: 'Invalid credentials for RADIUS machine account: <username>'
    },
    {
        value: 2443,
        subtitle: '#2443 • Info',
        title: 'Silverfort Service Account {SA username} does not have permissions to read {domain name} domain objects'
    },
    {
        value: 2444,
        subtitle: '#2444 • Info',
        title: 'Silverfort Service Account {SA username} does not have permissions to read {domain name} domain deleted objects'
    },
    {
        value: 2770,
        subtitle: '#2770 • Warning',
        title: 'The AD adapter was disconnected due to an unstable network connection. To reconnect the adapter, click Recover to the right of DC on the System Status page.'
    },
    {
        value: 2780,
        subtitle: '#2780 • Warning',
        title: 'An incompatible software {software_name}, uses a WFP filter that may cause the AD adapter not to function properly.'
    }
];

exports.DEFAULT_EMAIL = {
    name: '',
    creationDate: Date.now(),
    emails: [],
    activeEvents: {
        [EMAIL_TYPES.NOTIFICATIONS.id]: true
    },
    settings: {
        [EMAIL_TYPES.NOTIFICATIONS.id]: {
            default: { eventIds: this.SILVERFORT_RECOMMENDED_EVENTS.map((e) => e.value) },
            custom: { eventIds: [], severity: [] }
        }
    }
};

exports.EVENT_SEVERITIES = [
    { title: 'All Info events', value: 1 },
    { title: 'All Warning events', value: 2 },
    { title: 'All Error events', value: 3 }
];

exports.CUSTOMIZABLE_EVENTS = new Set([EMAIL_TYPES.NOTIFICATIONS.id]);
